import { bl_t2t_mst_role_RowClass } from "../../dbschema/bl_t2t_mst_role.model";
import { bl_t2t_mst_role_ext_RowClass } from "../../dbschema/bl_t2t_mst_role_ext.model";
import { bl_t2t_mst_role_line_RowClass } from "../../dbschema/bl_t2t_mst_role_line.model";

import { BaseContainerModel } from "../base-container.model";

export class T2TRolesContainerModel extends BaseContainerModel {
  app_mst_role: bl_t2t_mst_role_RowClass = new bl_t2t_mst_role_RowClass();
  app_mst_role_lines: bl_t2t_mst_role_line_RowClass[] = [];
  app_mst_role_exts: bl_t2t_mst_role_ext_RowClass[] = [];
}
